<template>
    <footer class="footer">
    <span>
      &copy; {{ new Date().getFullYear() }} Safety Codes Council
    </span>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
};
</script>

<style scoped>
footer {
  border-top: 1px solid #0F4B90;
  text-align: center;
  /* background: #2fa1ff; */
  color: #0F4B90;
}
.footer {
  flex-shrink: 0;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller
  than their content's default minimum size. */
  padding: 12px;
  text-align: left;
}
</style>
